import { differenceInDays } from 'date-fns/differenceInDays'

export function daysSince(pastDate: Date | string) {
  const today = new Date()
  const daysDifference = differenceInDays(today, new Date(pastDate))

  return daysDifference
}

export function daysRemaining(futureDate: Date | string) {
  const today = new Date()
  const daysDifference = differenceInDays(new Date(futureDate), today)

  return daysDifference
}

export function daysUntil(futureDate: Date | string) {
  return `${Math.abs(daysRemaining(futureDate))}d`
}

export const tierMonthsMap = {
  0: '3 Months',
  1: '6 Months',
  2: '12 Months',
}

export const vaultsTierMultipliersMap = {
  0: 1.1,
  1: 1.3,
  2: 1.5,
}

export const tokensTierMultipliersMap = {
  0: 1,
  1: 1.4,
  2: 2,
}
